import Button from "components/Button";
import { Grid } from "components/Grid/Grid";
import { Loader } from "components/Loader/Loader.component";
import Modal from "components/Modal";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import TextInput from "components/TextInput";
import { languageLevels } from "constants/options";
import PageContent from "pages/PageContent";
import {
    ProfileContentWrapper,
    StraightLine,
    SubHeading,
} from "pages/PageContent/PageContent.styled";
import { FC } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { RiDeleteBin5Line } from "react-icons/ri";
import theme from "theme";
import {
    ButtonContainer,
    CircularButton,
} from "../PersonalDetails/PersonalDetails.styled";
import { useLocationAndLanguages } from "./useLocationAndLanguages";

export const LocationAndLanguages: FC = () => {
    const {
        userLanguages,
        countriesData,
        addLanguage,
        removeLanguage,
        handleSave,
        languageData,
        handleChangeLanguages,
        userLocationErrors,
        handleChangeCity,
        handleChangeCountry,
        isLoading,
        userLocation,
        isSubmitting,
        handleSaveAndNext,
        clickedOnNext,
        handleBack,
        isModalOpen,
        toggleModal,
    } = useLocationAndLanguages();

    return (
        <PageContent>
            <ProfileContentWrapper>
                {isLoading && <Loader size={28} />}
                <Text
                    variant="heading5"
                    fontWeight="700"
                    color={theme.colors.grey.dark}
                >
                    Complete Your Profile (6/7)
                </Text>
                <SubHeading variant="label">
                    LOCATION <StraightLine />
                </SubHeading>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    marginBottom={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <SingleSelect
                        label="Country"
                        placeholder="Eg: India"
                        required
                        minWidth="250px"
                        options={countriesData}
                        value={userLocation.country}
                        searchable
                        onChange={handleChangeCountry}
                        errorText={userLocationErrors.country}
                    />
                    <TextInput
                        label="City"
                        placeholder="Eg. Mumbai"
                        required
                        minWidth="160px"
                        value={userLocation.city}
                        onChange={handleChangeCity}
                        errorMsg={userLocationErrors.city}
                    />
                </Grid>
                <SubHeading variant="label">
                    LANGUAGE <StraightLine />
                </SubHeading>
                {userLanguages.map((lang, index) => (
                    <Grid
                        row={true}
                        expanded
                        marginTop={2}
                        columnGap={1}
                        rowGap={1}
                        key={lang.id}
                    >
                        <SingleSelect
                            label="Select a Language"
                            placeholder="Eg: Hindi"
                            required
                            searchable
                            minWidth="160px"
                            options={languageData}
                            value={lang.language_id}
                            onChange={(value) =>
                                handleChangeLanguages(
                                    lang.id,
                                    "language_id",
                                    value
                                )
                            }
                            errorText={lang.language_error}
                        />
                        <SingleSelect
                            label="Level"
                            placeholder="Eg: Fluent"
                            required
                            minWidth="160px"
                            options={languageLevels}
                            value={lang.level}
                            onChange={(value) =>
                                handleChangeLanguages(lang.id, "level", value)
                            }
                        />
                        <ButtonContainer>
                            <CircularButton
                                type="button"
                                variant="flat"
                                onClick={() => {
                                    index === userLanguages.length - 1
                                        ? addLanguage()
                                        : removeLanguage(lang.id);
                                }}
                            >
                                {index === userLanguages.length - 1 ? (
                                    <AiOutlinePlus
                                        color="green"
                                        fontWeight={700}
                                    />
                                ) : (
                                    <RiDeleteBin5Line color="red" />
                                )}
                            </CircularButton>
                        </ButtonContainer>
                    </Grid>
                ))}
                <Grid
                    row={true}
                    columnGap={1}
                    marginTop={3}
                    marginBottom={1}
                    rowGap={1}
                >
                    <Button
                        type="button"
                        variant="outlined"
                        icon={<BsArrowLeft />}
                        iconPosition="prefix"
                        onClick={toggleModal}
                    >
                        Back
                    </Button>
                    <Button
                        type="button"
                        variant="outlined"
                        onClick={handleSave}
                        isLoading={!clickedOnNext && isSubmitting}
                    >
                        Save
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        icon={<BsArrowRight />}
                        isLoading={clickedOnNext && isSubmitting}
                        iconPosition="suffix"
                        onClick={handleSaveAndNext}
                    >
                        Save and Next
                    </Button>
                </Grid>
            </ProfileContentWrapper>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>
                    <Text variant="heading3">Confirm</Text>
                </Modal.Header>
                <Modal.Content>
                    <Text variant="body1">
                        Are you sure you want to leave? Any unsaved changes will
                        be lost.
                    </Text>
                </Modal.Content>
                <Modal.Footer>
                    <Grid
                        row={true}
                        justify="flex-end"
                        expanded
                        columnGap={1}
                        marginTop={2}
                        rowGap={1}
                    >
                        <Button
                            type="button"
                            variant="outlined"
                            onClick={toggleModal}
                        >
                            No
                        </Button>
                        <Button
                            type="button"
                            variant="filled"
                            onClick={handleBack}
                        >
                            Yes
                        </Button>
                    </Grid>
                </Modal.Footer>
            </Modal>
        </PageContent>
    );
};
